<template>
  <div class="breadcrumb">
    <div class="breadcrumb-items">
      <div v-for="(item, index) in breadcrumbItems" :key="index" class="breadcrumb-item">
        <NuxtLink
          v-if="item.path && index < breadcrumbItems.length - 1"
          :to="item.path"
          class="breadcrumb-link"
        >
          {{ item.name }}
        </NuxtLink>
        <span v-else class="breadcrumb-current">
          {{ item.name }}
        </span>
        <IconArrow
          v-if="index < breadcrumbItems.length - 1"
          class="text-[var(--x-text-5)] text-[18px] w-[18px] h-[18px] -rotate-90"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IconArrow from '~/assets/svg/icon-dropdown.svg?component';
import { PageKey } from '~/constants/page';

const { t: $t } = useI18n();

const props = defineProps<{
  title?: string;
}>();

interface BreadcrumbItem {
  name: string;
  path?: string;
}

const route = useRoute();

const breadcrumbItems = computed(() => {
  const items: BreadcrumbItem[] = [];

  // 添加首页
  items.push({
    name: $t('you-yan'),
    path: '/',
  });

  items.push({
    name: $t('mo-fa-xue-yuan'),
    path: '/academy',
  });

  if (route.name === PageKey.CASE_DETAIL) {
    items.push({
      path: '/customer-stories',
      name: $t('ke-hu-an-li'),
    });
  }

  // 如果当前路由不是 displayInfo 中的路径，添加当前页面作为最后一项
  // 可以根据路由参数或其他信息生成当前页面标题
  const currentPageTitle =
    route.meta?.title || route.params?.title || props.title || $t('dang-qian-ye-mian');

  items.push({
    name: currentPageTitle as string,
  });

  return items;
});
</script>

<style scoped>
.breadcrumb {
}

.breadcrumb-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.breadcrumb-link {
  color: var(--x-text-5);
  text-decoration: none;
  font-size: 16px;
  transition: color 0.2s ease;
  line-height: normal;
}

.breadcrumb-link:hover {
  color: var(--x-purple-7);
}

.breadcrumb-current {
  color: var(--x-text-1);
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}
</style>
